<template>
<div v-if="password" class="strength-meter" :class="'strength-meter--' + levelKey" role="status" :aria-label="'Seguridad: ' + levelLabel">
    <div class="strength-meter__bar">
        <span
        v-for="n in 5"
        :key="n"
        class="strength-meter__segment"
        :class="{ 'strength-meter__segment--filled': n <= metCount }"
        ></span>
    </div>
    <p class="strength-meter__label">Seguridad: {{ levelLabel }}</p>
</div>
</template>

<script>
import { passwordRequirements } from '@/utils/passwordPolicy.js'

// Nivel según requisitos cumplidos (misma fuente que la regla strong_password):
// 1-2 Débil, 3-4 Media, 5 Fuerte. El nivel siempre se comunica también en
// texto, nunca solo con color.
export default {
  name: 'PasswordStrengthMeter',
  props: {
    password: {
      type: String,
      default: ''
    }
  },
  computed: {
    metCount: function () {
      var pw = this.password || ''
      return passwordRequirements.filter(function (req) { return req.test(pw) }).length
    },
    levelKey: function () {
      if (this.metCount <= 2) return 'weak'
      if (this.metCount <= 4) return 'medium'
      return 'strong'
    },
    levelLabel: function () {
      if (this.levelKey === 'weak') return 'Débil'
      if (this.levelKey === 'medium') return 'Media'
      return 'Fuerte'
    }
  }
}
</script>

<style lang="scss" scoped>
.strength-meter {
    margin-top: 0.4rem;

    &__bar {
        display: flex;
        gap: 2px;
    }

    &__segment {
        flex: 1;
        height: 6px;
        border-radius: 3px;
        background: var(--color-line);
        transition: background-color 150ms ease;
    }

    &__label {
        margin: 0.25rem 0 0;
        font-size: 0.78rem;
        color: var(--color-graphite);
    }

    &--weak &__segment--filled {
        background: var(--color-danger);
    }

    &--medium &__segment--filled {
        background: var(--color-orange);
    }

    &--strong &__segment--filled {
        background: var(--color-success);
    }
}
</style>
